import { FaCcVisa } from 'react-icons/fa';

const VisaCard = ({ size = 48, color = "#1a1f71" }) => {
    return <FaCcVisa size={size} color={color} />
}

export default VisaCard